/** Solid dot colors for status/priority values, keyed to match STATUS_CONFIG in StatusBadge.tsx where applicable. */
export type DotConfig = Record<string, string>;

export const STATUS_DOT_CONFIG: DotConfig = {
    draft: 'bg-slate-400',
    sent: 'bg-blue-500',
    approved: 'bg-emerald-500',
    rejected: 'bg-red-500',
    revised: 'bg-amber-500',
    paid: 'bg-emerald-500',
    partial: 'bg-yellow-500',
    overdue: 'bg-orange-500',
    delivered: 'bg-teal-500',
    converted: 'bg-purple-500',
    pending_approval: 'bg-amber-500',
    checked: 'bg-cyan-500',
    conditional: 'bg-yellow-500',
    blacklisted: 'bg-red-600',
    new: 'bg-sky-500',
    in_discussion: 'bg-indigo-500',
    qualified: 'bg-emerald-500',
    disqualified: 'bg-red-500',
    closed: 'bg-slate-500',
    active: 'bg-blue-500',
    on_hold: 'bg-amber-500',
    completed: 'bg-emerald-500',
    cancelled: 'bg-slate-400',
    in_progress: 'bg-blue-500',
    received: 'bg-teal-500',
    flagged: 'bg-red-500',
    qa_passed: 'bg-emerald-500',
    qa_failed: 'bg-red-500',
    open: 'bg-sky-500',
    resolved: 'bg-emerald-500',
    pending: 'bg-amber-500',
    passed: 'bg-emerald-500',
    failed: 'bg-red-500',
    superseded: 'bg-slate-400',
    replied: 'bg-blue-500',
    finalized: 'bg-emerald-500',
    unpaid: 'bg-orange-500',
    quick_vendor: 'bg-sky-500',
    half_day: 'bg-amber-500',
    leave: 'bg-purple-500',
    holiday: 'bg-teal-500',
    weekoff: 'bg-slate-400',
    present: 'bg-emerald-500',
    absent: 'bg-red-500',
    inactive: 'bg-slate-400',
    terminated: 'bg-red-500',
    on_leave: 'bg-purple-500',
    dispatched: 'bg-blue-500',
    processing: 'bg-blue-500',
};

export const PRIORITY_DOT_CONFIG: DotConfig = {
    low: 'bg-slate-400',
    medium: 'bg-blue-500',
    normal: 'bg-blue-500',
    high: 'bg-amber-500',
    urgent: 'bg-orange-500',
    critical: 'bg-red-600',
};

export const getDotColor = (config: DotConfig, value?: string) =>
    (value && (config[value] ?? config[value.toLowerCase()])) || 'bg-slate-400';
